export default __webpack_public_path__ + "media/zurb/img/home/xurrent-rebrand-554a34d7e412dc82090fc4417d25586b.png";